import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    sectionTitle: 'Payment',
    selectOneError: 'Please select at least one payment method',
  },
  fr: {
    sectionTitle: 'Paiement',
    selectOneError: 'Choisissez au moins un moyen de paiement pour continuer',
  },
} as const);

export default locales;
